// Ciudades Imperiales + Rif · 7 nights / 8 days
// Tánger → Tetuán → Chefchaouen → Rabat → Volubilis/Meknes → Fez → Atlas → Marrakech
// Adds a dedicated Rabat night between Chefchaouen and the Volubilis/Meknes
// day, expanding the 6n/7d version with the imperial capital.
import {
  DAY_CIRF_TANGER_TETUAN,
  DAY_CIRF_CHEFCHAOUEN,
  DAY_CIRF_FEZ_MEDINA,
  DAY_CIRF_FEZ_MARRAKECH,
  DAY_CIRF_MARRAKECH_MEDINA,
  DAY_CIRF_RETURN_MARRAKECH,
} from "@/lib/programs/ciudadesImperialesRif67";

const T = (es, en, fr) => ({ es, en, fr });

const DAY_CHEFCHAOUEN_RABAT = {
  route_id: "cirf78-chefchaouen-rabat",
  id: "cirf78-d3",
  image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=2000&q=85",
  accent: "#5A7F9C",
  title: T(
    "Chefchaouen · traslado a Rabat · visita guiada",
    "Chefchaouen · transfer to Rabat · guided tour",
    "Chefchaouen · transfert vers Rabat · visite guidée",
  ),
  chronologySummary: T(
    "De Chefchaouen descendemos por la costa atlántica hasta Rabat para descubrir la Kasbah de los Oudaias, la Torre Hassan y el Chellah.",
    "From Chefchaouen we follow the Atlantic coast to Rabat to discover the Kasbah of the Oudaias, Hassan Tower and Chellah.",
    "De Chefchaouen, nous longeons la côte atlantique jusqu’à Rabat pour découvrir la Kasbah des Oudaïas, la tour Hassan et le Chellah.",
  ),
  body: {
    es: "Salida temprano en dirección Rabat, una mañana íntegra dedicada al traslado por la costa atlántica con paisajes cambiantes entre el Rif y el océano. A primera hora de la tarde, visita guiada de Rabat, la capital del país, con un guía local. Recorreremos sus joyas más emblemáticas: la Kasbah des Oudaias — barrio fortificado magníficamente conservado, construido sobre un acantilado desde donde se contempla la ciudad vecina de Salé al otro lado del Bou Regreg —, la Torre Hassan y el Mausoleo de Mohammed V, y el Chellah, antigua ciudad romana y medieval reconvertida en necrópolis merení. Cena y alojamiento en Hotel 4★ o Riad en Rabat.",
    en: "Early departure to Rabat — a morning dedicated to the transfer along the Atlantic coast, with shifting landscapes between the Rif and the ocean. Early afternoon guided tour of Rabat, the country's capital, with a local guide. We cover its most emblematic gems: the Kasbah des Oudaias — a beautifully preserved fortified neighbourhood built on a cliff overlooking the neighbouring city of Salé across the Bou Regreg —, Hassan Tower and the Mausoleum of Mohammed V, and Chellah, an ancient Roman and medieval city reborn as a Merinid necropolis. Dinner and overnight in a 4★ hotel or riad in Rabat.",
    fr: "Départ matinal vers Rabat — matinée consacrée au transfert le long de la côte atlantique, avec des paysages contrastés entre le Rif et l'océan. Début d'après-midi, visite guidée de Rabat, capitale du pays, avec un guide local. Au programme : la Kasbah des Oudaïas — quartier fortifié magnifiquement conservé, construit sur une falaise dominant la ville voisine de Salé de l'autre côté du Bou Regreg —, la tour Hassan et le mausolée de Mohammed V, et le Chellah, ancienne ville romaine et médiévale reconvertie en nécropole mérinide. Dîner et nuit en hôtel 4★ ou riad à Rabat.",
  },
  culture: [
    {
      title: T("Rabat · capital UNESCO desde 2012", "Rabat · UNESCO capital since 2012", "Rabat · capitale UNESCO depuis 2012"),
      body: T(
        "Capital política, administrativa y diplomática. Su tejido urbano combina la herencia almohade, andalusí y francesa moderna — reconocido como Patrimonio Mundial en 2012.",
        "Political, administrative and diplomatic capital. Its urban fabric blends Almohad, Andalusian and modern French heritage — UNESCO World Heritage since 2012.",
        "Capitale politique, administrative et diplomatique. Son tissu urbain mêle héritage almohade, andalou et français — Patrimoine UNESCO depuis 2012.",
      ),
    },
    {
      title: T("Chellah · Roma y la dinastía meriní", "Chellah · Rome and the Merinid dynasty", "Chellah · Rome et la dynastie mérinide"),
      body: T(
        "Yacimiento romano de Sala Colonia (s. III a.C.) reutilizado como necrópolis real meriní en el siglo XIV. Sus jardines son ahora santuario de cigüeñas.",
        "Roman site of Sala Colonia (3rd c. BC) reused as a Merinid royal necropolis in the 14th century. Its gardens are now a stork sanctuary.",
        "Site romain de Sala Colonia (IIIe s. av. J.-C.) réutilisé comme nécropole royale mérinide au XIVe siècle. Ses jardins abritent aujourd'hui des cigognes.",
      ),
    },
  ],
};

const DAY_VOLUBILIS_MEKNES_FEZ = {
  route_id: "cirf78-volubilis-meknes-fez",
  id: "cirf78-d4",
  image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2000&q=85",
  accent: "#5A6B4F",
  title: T(
    "Rabat · Volubilis · Moulay Idriss · Meknès · Fez",
    "Rabat · Volubilis · Moulay Idriss · Meknès · Fez",
    "Rabat · Volubilis · Moulay Idriss · Meknès · Fès",
  ),
  chronologySummary: T(
    "Visitamos las ruinas romanas de Volubilis, la ciudad santa de Moulay Idriss y los monumentos imperiales de Meknes antes de llegar a Fez.",
    "We visit Roman Volubilis, holy Moulay Idriss and the imperial monuments of Meknes before reaching Fez for the evening.",
    "Nous visitons Volubilis, la ville sainte de Moulay Idriss et les monuments impériaux de Meknès avant de rejoindre Fès en soirée.",
  ),
  body: {
    es: "Salida temprano hacia Meknès. Durante la ruta visitaremos Volubilis, el yacimiento arqueológico romano más grande de Marruecos — Arco de Triunfo de Caracalla, Capitolio, Casa de Baco y los espectaculares mosaicos in situ forman este tesoro al aire libre. Pasaremos también por Moulay Idriss, ciudad santa donde el fundador de Fez convirtió al Islam a la población bereber local — sus casas blancas escalonadas alrededor del mausoleo crean uno de los lugares más espirituales del país. Llegada a Meknès, una de las ciudades imperiales más hermosas y poderosas de Marruecos. Visita guiada con guía local. Su medina, más pequeña y tranquila que la de Fez, conserva una importancia histórica enorme: fundada en el siglo X por una tribu bereber, se convirtió en capital del país en el siglo XVII y forma parte del Patrimonio UNESCO. La ciudad está protegida por más de 40 km de murallas; destaca especialmente la monumental Bab al Mansour. Visitaremos el Mausoleo de Moulay Ismaïl, los graneros y caballerizas «Heri es Souani» y la prisión subterránea «Habs Qara». Tras la visita, continuación hacia Fez (≈ 60 km). Cena y alojamiento en riad dentro de la medina o hotel 4★.",
    en: "Early departure to Meknès. On the way we visit Volubilis, Morocco's largest Roman archaeological site — Caracalla's Triumphal Arch, the Capitol, the House of Bacchus and the spectacular in-situ mosaics make up this open-air treasure. We then pass through Moulay Idriss, holy city where the founder of Fez converted the local Berber population to Islam — its white houses cascading around the mausoleum make it one of the most spiritual sites in the country. We arrive in Meknès, one of Morocco's most beautiful and powerful imperial cities. Guided tour with a local guide. Its medina — smaller and quieter than Fez — holds enormous historical weight: founded by a Berber tribe in the 10th century, it became the country's capital in the 17th and is UNESCO listed. The city is wrapped in over 40 km of ramparts; the monumental Bab al Mansour stands out. We visit the Mausoleum of Moulay Ismaïl, the «Heri es Souani» granaries and royal stables, and the underground «Habs Qara» prison. Onwards to Fez (≈ 60 km). Dinner and overnight in a medina riad or 4★ hotel.",
    fr: "Départ matinal vers Meknès. En route, visite de Volubilis, le plus vaste site archéologique romain du Maroc — arc de triomphe de Caracalla, Capitole, maison de Bacchus et les spectaculaires mosaïques in situ. Passage par Moulay Idriss, ville sainte où le fondateur de Fès convertit la population berbère locale à l'islam — ses maisons blanches en cascade autour du mausolée en font l'un des sites les plus spirituels du pays. Arrivée à Meknès, l'une des plus belles et plus puissantes cités impériales du Maroc. Visite guidée avec un guide local. Sa médina — plus petite et plus tranquille que celle de Fès — est d'une grande importance historique : fondée par une tribu berbère au Xe siècle, devenue capitale du pays au XVIIe siècle, et inscrite au Patrimoine UNESCO. La ville est ceinte par plus de 40 km de remparts ; la monumentale Bab al Mansour est particulièrement remarquable. Visite du mausolée de Moulay Ismaïl, des greniers et écuries royales « Heri es Souani » et de la prison souterraine « Habs Qara ». Route vers Fès (≈ 60 km). Dîner et nuit en riad de la médina ou hôtel 4★.",
  },
  culture: [
    {
      title: T("Volubilis · UNESCO", "Volubilis · UNESCO", "Volubilis · UNESCO"),
      body: T(
        "Capital de la Mauretania Tingitana entre el siglo I a.C. y el III. Patrimonio UNESCO desde 1997 — sus mosaicos in situ figuran entre los mejor conservados del Imperio.",
        "Capital of Mauretania Tingitana from the 1st c. BC to the 3rd c. UNESCO World Heritage since 1997 — its in-situ mosaics are among the best preserved in the Empire.",
        "Capitale de la Maurétanie Tingitane entre le Ier s. av. J.-C. et le IIIe siècle. Patrimoine UNESCO depuis 1997.",
      ),
    },
    {
      title: T("Bab al Mansour · puerta imperial", "Bab al Mansour · imperial gate", "Bab al Mansour · porte impériale"),
      body: T(
        "Construida en 1732 con columnas saqueadas a Volubilis, sus zellige y bajorrelieves la consagran como la puerta monumental más bella de Marruecos.",
        "Built in 1732 with columns looted from Volubilis, its zellige and bas-reliefs make it Morocco's most beautiful monumental gate.",
        "Construite en 1732 avec des colonnes pillées à Volubilis, ses zellige et bas-reliefs en font la plus belle porte monumentale du Maroc.",
      ),
    },
  ],
};

export const PROGRAM_CI_RIF_78 = {
  routeId: "tourCiudadesImperialesRif78",
  chronologyVariant: "cirf",
  duration_key: "cirf7n8d",
  duration: T("7 noches / 8 días", "7 nights / 8 days", "7 nuits / 8 jours"),
  prices: { low: 1490, mid: 1690, high: 1890, premium: 2090 },
  meta: {
    es: {
      title: "Ciudades imperiales y el Rif · de Tánger a Marrakech.",
      eyebrow_prefix: "Circuito · Ciudades imperiales + Rif",
      place: "Tánger · Tetuán · Chefchaouen · Rabat · Meknès · Fez · Marrakech",
      subtitle: "Ocho días desde el Estrecho de Gibraltar hasta el pie del Atlas — Tetuán, Chefchaouen el pueblo azul, las cuatro capitales imperiales y la travesía del Medio Atlas.",
      hero_image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
      airports: "Entrada Tánger · Salida Marrakech",
      quick_airports: "Tánger / Marrakech",
      quick_places: "Tánger · Tetuán · Chefchaouen · Rabat · Volubilis · Meknès · Fez · Ifrane · Marrakech",
      highlights: "Cabo Espartel · Chefchaouen · Chellah · Volubilis · Fez el-Bali · Djemaa el-Fna",
      description_title: "El Marruecos más cultural · norte a sur.",
      description: [
        "Marruecos posee un rico legado histórico y arquitectónico que podemos apreciar especialmente en sus llamadas «Ciudades Imperiales».",
        "Para quienes desean una inmersión profunda en el Marruecos más cultural, este circuito recorre el país de norte a sur añadiendo la magia del Rif y la herencia andalusí del antiguo Protectorado español.",
        "Ocho días entre el Estrecho de Gibraltar, los pueblos azules del Rif, los mosaicos romanos de Volubilis, las cuatro capitales imperiales y el bullicio de Djemaa el-Fna.",
      ],
    },
    en: {
      title: "Imperial cities and the Rif · from Tangier to Marrakech.",
      eyebrow_prefix: "Circuit · Imperial cities + Rif",
      place: "Tangier · Tetouan · Chefchaouen · Rabat · Meknès · Fez · Marrakech",
      subtitle: "Eight days from the Strait of Gibraltar to the foot of the Atlas — Tetouan, blue Chefchaouen, the four imperial capitals and the Middle Atlas crossing.",
      hero_image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
      airports: "In Tangier · Out Marrakech",
      quick_airports: "Tangier / Marrakech",
      quick_places: "Tangier · Tetouan · Chefchaouen · Rabat · Volubilis · Meknès · Fez · Ifrane · Marrakech",
      highlights: "Cape Spartel · Chefchaouen · Chellah · Volubilis · Fez el-Bali · Jemaa el-Fna",
      description_title: "Morocco at its most cultural · north to south.",
      description: [
        "Morocco holds a rich historic and architectural legacy especially visible in its «Imperial Cities».",
        "For those who want a deep dive into Morocco's most cultural face, this circuit travels the country from north to south adding the magic of the Rif and the Andalusian heritage of the former Spanish Protectorate.",
        "Eight days between the Strait of Gibraltar, the blue villages of the Rif, the Roman mosaics of Volubilis, the four imperial capitals and the buzz of Jemaa el-Fna.",
      ],
    },
    fr: {
      title: "Cités impériales et le Rif · de Tanger à Marrakech.",
      eyebrow_prefix: "Circuit · Cités impériales + Rif",
      place: "Tanger · Tétouan · Chefchaouen · Rabat · Meknès · Fès · Marrakech",
      subtitle: "Huit jours du détroit de Gibraltar au pied de l'Atlas — Tétouan, Chefchaouen la bleue, les quatre capitales impériales et la traversée du Moyen Atlas.",
      hero_image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2400&q=85",
      airports: "Arrivée Tanger · Sortie Marrakech",
      quick_airports: "Tanger / Marrakech",
      quick_places: "Tanger · Tétouan · Chefchaouen · Rabat · Volubilis · Meknès · Fès · Ifrane · Marrakech",
      highlights: "Cap Spartel · Chefchaouen · Chellah · Volubilis · Fès el-Bali · Jemaa el-Fna",
      description_title: "Le Maroc le plus culturel · nord vers sud.",
      description: [
        "Le Maroc conserve un riche héritage historique et architectural particulièrement visible dans ses « cités impériales ».",
        "Pour ceux qui veulent une plongée profonde dans le Maroc le plus culturel, ce circuit traverse le pays du nord au sud en ajoutant la magie du Rif et l'héritage andalou de l'ancien Protectorat espagnol.",
        "Huit jours entre le détroit de Gibraltar, les villages bleus du Rif, les mosaïques romaines de Volubilis, les quatre capitales impériales et l'effervescence de Jemaa el-Fna.",
      ],
    },
  },
  route: [
    { day: 1, lat: 35.7595, lng: -5.8340, type: "city",    name: T("Tánger · Cabo Espartel · Grutas de Hércules", "Tangier · Cape Spartel · Caves of Hercules", "Tanger · Cap Spartel · Grottes d'Hercule") },
    { day: 1, lat: 35.5732, lng: -5.3729, type: "city",    name: T("Tetuán · «La Paloma Blanca»", "Tetouan · «the White Dove»", "Tétouan · « la Colombe Blanche »") },
    { day: 2, lat: 35.1714, lng: -5.2700, type: "city",    name: T("Chefchaouen · el pueblo azul", "Chefchaouen · the blue town", "Chefchaouen · le village bleu") },
    { day: 3, lat: 34.0209, lng: -6.8416, type: "city",    name: T("Rabat · Kasbah des Oudaias · Chellah", "Rabat · Kasbah des Oudaias · Chellah", "Rabat · Kasbah des Oudaïas · Chellah") },
    { day: 4, lat: 34.0742, lng: -5.5550, type: "unesco",  name: T("Volubilis · ruinas romanas", "Volubilis · Roman ruins", "Volubilis · ruines romaines") },
    { day: 4, lat: 33.8930, lng: -5.5473, type: "city",    name: T("Meknès · Bab al Mansour", "Meknès · Bab al Mansour", "Meknès · Bab al Mansour") },
    { day: 5, lat: 34.0635, lng: -4.9737, type: "unesco",  name: T("Fez el-Bali · medina UNESCO", "Fez el-Bali · UNESCO medina", "Fès el-Bali · médina UNESCO") },
    { day: 6, lat: 33.5333, lng: -5.1100, type: "city",    name: T("Ifrane · cedros · Atlas · Beni Mellal", "Ifrane · cedars · Atlas · Beni Mellal", "Ifrane · cèdres · Atlas · Beni Mellal") },
    { day: 7, lat: 31.6244, lng: -7.9926, type: "city",    name: T("Marrakech · Koutoubia · Palacio de la Bahía", "Marrakech · Koutoubia · Bahia Palace", "Marrakech · Koutoubia · Palais de la Bahia") },
    { day: 8, lat: 31.6069, lng: -8.0363, type: "airport", name: T("Marrakech · Aeropuerto · Regreso", "Marrakech · Airport · Return", "Marrakech · Aéroport · Retour") },
  ],
  days: [
    DAY_CIRF_TANGER_TETUAN,
    DAY_CIRF_CHEFCHAOUEN,
    DAY_CHEFCHAOUEN_RABAT,
    DAY_VOLUBILIS_MEKNES_FEZ,
    DAY_CIRF_FEZ_MEDINA,
    DAY_CIRF_FEZ_MARRAKECH,
    DAY_CIRF_MARRAKECH_MEDINA,
    DAY_CIRF_RETURN_MARRAKECH,
  ],
  details: {
    includes: {
      es: [
        "Una noche en Tetuán en Riad en la Medina u Hotel 4★ · Media Pensión",
        "Una noche en Chefchaouen en Riad en la Medina · Media Pensión",
        "Una noche en Rabat en Riad en la Medina u Hotel 4★ · Media Pensión",
        "Dos noches en Fez en Riad en la Medina u Hotel 4★ · Media Pensión",
        "Dos noches en Marrakech en Riad en la Medina u Hotel 5★ · Alojamiento y Desayuno",
        "Vehículo turismo o 4x4 con chófer del día 1 al día 6 del itinerario, ambos incluidos",
        "Visita de las Grutas de Hércules",
        "Visita con guía local en Tetuán (medio día)",
        "Visita con guía local en Chefchaouen (medio día)",
        "Visita con guía local en Rabat (medio día) · Entrada al Chellah",
        "Visita de Volubilis con entrada y guía",
        "Visita con guía local en Meknès (medio día) · Entradas a Heri es Souani y Habs Qara",
        "Visita con guía local en Fez (1 día) · Entrada a la Madraza",
        "Visita con guía local en Marrakech (medio día) · Entrada al Palacio de la Bahía",
        "Transfers desde y hacia aeropuertos",
        "Seguro de asistencia en viaje",
      ],
      en: [
        "One night in Tetouan in a Medina riad or 4★ hotel · half board",
        "One night in Chefchaouen in a medina riad · half board",
        "One night in Rabat in a medina riad or 4★ hotel · half board",
        "Two nights in Fez in a Medina riad or 4★ hotel · half board",
        "Two nights in Marrakech in a Medina riad or 5★ hotel · bed & breakfast",
        "Car or 4x4 with driver from day 1 to day 6 inclusive",
        "Caves of Hercules entrance",
        "Local guided tour in Tetouan (half day)",
        "Local guided tour in Chefchaouen (half day)",
        "Local guided tour in Rabat (half day) · Chellah entrance",
        "Volubilis admission and licensed guide",
        "Local guided tour in Meknès (half day) · Heri es Souani and Habs Qara entrances",
        "Local guided tour in Fez (full day) · Madrasa entrance",
        "Local guided tour in Marrakech (half day) · Bahia Palace entrance",
        "Airport transfers",
        "Travel assistance insurance",
      ],
      fr: [
        "Une nuit à Tétouan en riad de la médina ou hôtel 4★ · demi-pension",
        "Une nuit à Chefchaouen en riad de la médina · demi-pension",
        "Une nuit à Rabat en riad de la médina ou hôtel 4★ · demi-pension",
        "Deux nuits à Fès en riad de la médina ou hôtel 4★ · demi-pension",
        "Deux nuits à Marrakech en riad de la médina ou hôtel 5★ · petit-déjeuner",
        "Voiture ou 4x4 avec chauffeur du jour 1 au jour 6 inclus",
        "Entrée aux Grottes d'Hercule",
        "Guide local à Tétouan (demi-journée)",
        "Guide local à Chefchaouen (demi-journée)",
        "Guide local à Rabat (demi-journée) · Entrée du Chellah",
        "Volubilis : entrée et guide diplômé",
        "Guide local à Meknès (demi-journée) · Entrées à Heri es Souani et Habs Qara",
        "Guide local à Fès (1 jour) · Entrée à la médersa",
        "Guide local à Marrakech (demi-journée) · Entrée au palais de la Bahia",
        "Transferts aéroport",
        "Assistance voyage",
      ],
    },
    excludes: {
      es: [
        "Las bebidas",
        "Las comidas a mediodía",
        "Las cenas de Marrakech",
        "Visitas o guías no detallados en el incluye",
        "Otros extras personales (hammam, masajes, etc.)",
        "El vuelo (salvo que se indique lo contrario)",
        "Suplemento opcional para seguro de cancelación · 45 € por persona para viajes de hasta 9 días",
      ],
      en: [
        "Drinks",
        "Lunches",
        "Dinners in Marrakech",
        "Tours or guides not detailed",
        "Personal extras (hammam, massages, etc.)",
        "Flights (unless otherwise stated)",
        "Optional cancellation insurance · €45 per person for trips up to 9 days",
      ],
      fr: [
        "Boissons",
        "Déjeuners",
        "Dîners à Marrakech",
        "Visites ou guides non détaillés",
        "Extras personnels (hammam, massages, etc.)",
        "Le vol (sauf mention contraire)",
        "Assurance annulation en option · 45 € par personne pour les voyages jusqu'à 9 jours",
      ],
    },
    notes: {
      es: [
        "Opciones de vuelos: Royal Air Maroc vía Casablanca o low-cost (Vueling, Ryanair) con vuelos directos desde las principales ciudades.",
        "Las tarifas dependen de la ocupación del vehículo turismo o 4x4 que nos acompaña durante todo el recorrido.",
        "Tarifas basadas en habitaciones dobles y triples. Suplemento individual: 375 €.",
        "Descuento niños (3-11 años) compartiendo habitación con dos adultos: 220 €.",
        "En temporada alta, los guías locales de las medinas pueden compartirse con otros viajeros.",
        "Los chóferes hispanohablantes son limitados — reservar con antelación.",
        "El viaje se realiza en vehículo turismo o 4x4 con chófer. Los guías oficiales se reservan exclusivamente para las medinas, no para las rutas.",
        "Consultar alternativas opcionales para hacer el trayecto Fez-Marrakech en avión o ampliar una noche en el Lago Bin el Ouidane.",
        "Pasaporte obligatorio con vigencia mínima de 6 meses.",
      ],
      en: [
        "Flight options: Royal Air Maroc via Casablanca or low-cost (Vueling, Ryanair) with direct flights from major cities.",
        "Rates depend on the occupancy of the car or 4x4 used throughout the route.",
        "Rates based on double and triple rooms. Single supplement: €375.",
        "Children discount (3-11) sharing room with two adults: €220.",
        "In high season, medina guides may be shared with other travellers.",
        "Spanish-speaking drivers are limited — book early.",
        "Travel by car or 4x4 with driver. Official guides are reserved for medina visits only.",
        "Alternatives available: Fez-Marrakech leg by plane or extra night at Bin el Ouidane Lake.",
        "Valid passport required with at least 6 months remaining.",
      ],
      fr: [
        "Options de vol : Royal Air Maroc via Casablanca ou low-cost (Vueling, Ryanair).",
        "Tarifs selon l'occupation de la voiture ou du 4x4 utilisé pendant tout le parcours.",
        "Tarifs base chambre double et triple. Supplément single : 375 €.",
        "Réduction enfants (3-11 ans) partageant avec deux adultes : 220 €.",
        "En haute saison, les guides de médina peuvent être partagés.",
        "Chauffeurs hispanophones limités — réserver tôt.",
        "Voyage en voiture ou 4x4 avec chauffeur. Les guides officiels sont réservés aux médinas.",
        "Alternatives : trajet Fès-Marrakech en avion ou nuit supplémentaire au lac Bin el Ouidane.",
        "Passeport valable au moins 6 mois.",
      ],
    },
    terms: {
      es: [
        "Ficha de inscripción obligatoria. Pago por transferencia o Visa.",
        "Reserva: 30% del importe total al confirmar.",
        "Pago final: 70% restante hasta 30 días antes de la salida.",
        "Si el vuelo elegido requiere emisión inmediata: 100% del vuelo + 30% de los servicios de tierra al reservar.",
        "Cancelación 45 días antes de la salida: 30% del importe total.",
        "Cancelación 21 días antes de la salida: 100% del importe total.",
        "Penalización fija de 50 € por reserva en concepto de gastos de gestión.",
        "Estas condiciones aplican sólo a los servicios de tierra. Los vuelos se rigen por las condiciones de cada compañía aérea. El seguro de cancelación no se reembolsa.",
      ],
      en: [
        "Compulsory booking form. Payment by bank transfer or Visa.",
        "Booking: 30% at confirmation.",
        "Final payment: 70% balance up to 30 days before departure.",
        "If the chosen flight requires immediate ticketing: 100% of the flight + 30% of land services at booking.",
        "Cancellation 45 days before departure: 30% of the total.",
        "Cancellation 21 days before departure: 100% of the total.",
        "Fixed €50 per booking management fee.",
        "Conditions apply to land services only. Cancellation insurance is non-refundable.",
      ],
      fr: [
        "Fiche d'inscription obligatoire. Paiement par virement ou Visa.",
        "Réservation : 30 % à la confirmation.",
        "Paiement final : solde de 70 % jusqu'à 30 jours avant le départ.",
        "Si le vol exige une émission immédiate : 100 % du vol + 30 % des services terrestres à la réservation.",
        "Annulation 45 jours avant : 30 % du total.",
        "Annulation 21 jours avant : 100 % du total.",
        "Pénalité fixe de 50 € par réservation pour frais de gestion.",
        "Conditions applicables aux services terrestres uniquement. L'assurance annulation n'est pas remboursable.",
      ],
    },
  },
};

export default PROGRAM_CI_RIF_78;
